import generalApi from "../api/generalApi";

let updateCheckInterval = null;
let currentVersion = "";
let updateCallback = null;

async function checkForUpdate() {
  const status = await generalApi.checkStatus();
  if (status && updateCallback(status)) {
    updateCallback(status);
  } else {
    if (status.frontEndVersion !== currentVersion) {
      window.location.reload(true);
    }
  }
  console.log(status);
}

const startUpdateCheck = function(interval, version, callback) {
  updateCallback = callback;
  currentVersion = version;
  interval = interval * 1000 * 60;
  updateCheckInterval = setInterval(checkForUpdate, interval);
  console.log(`Starting update check interval: ${interval}`);
};

const stopUpdateCheck = function() {
  currentVersion = "";
  updateCallback = null;
  clearInterval(updateCheckInterval);
};

export default {
  startUpdateCheck,
  stopUpdateCheck,
};
